const doc = [({"en":({"js":({"admin":({"activities":({"politics":({"proposals":({"politics":"Politics"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;